import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  DirectionsCarOutlined,
  LocationOnOutlined,
  PersonOutlined,
  PhoneOutlined,
  ScaleOutlined,
  StraightenOutlined,
  LocalShippingOutlined,
  SettingsOutlined,
  ReceiptLongOutlined,
} from "@mui/icons-material";

import { useVehicleListingDetailContext } from "contexts/VehicleListingDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

const VehicleListingBasicDetail = () => {
  const { vehicleListingDetail, loadingVehicleListing } =
    useVehicleListingDetailContext();

  return !loadingVehicleListing ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <DirectionsCarOutlined color="primary" />}
            title="Registration Number"
            subtitle={vehicleListingDetail?.vehicleRegistrationNumber || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <DirectionsCarOutlined color="primary" />}
            title="Vehicle Type"
            subtitle={vehicleListingDetail?.vehicleType?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Base Location"
            subtitle={vehicleListingDetail?.baseLocation || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Body Type"
            subtitle={vehicleListingDetail?.bodyType?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <SettingsOutlined color="primary" />}
            title="Drive Type"
            subtitle={vehicleListingDetail?.driveType?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <ScaleOutlined color="primary" />}
            title="Payload"
            subtitle={vehicleListingDetail?.payload?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <StraightenOutlined color="primary" />}
            title="Length"
            subtitle={vehicleListingDetail?.length?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <ReceiptLongOutlined color="primary" />}
            title="Has VAT/Bill"
            subtitle={
              <Box display="flex" alignItems="start" mt={1}>
                <Chip
                  label={vehicleListingDetail?.hasVATBill ? "Has VAT Bill" : "No VAT Bill"}
                  size="small"
                  sx={{
                    backgroundColor: vehicleListingDetail?.hasVATBill
                      ? "#E9F7EF"
                      : "#F8F9F9",
                    color: vehicleListingDetail?.hasVATBill
                      ? "green"
                      : "#7F8C8D",
                    fontWeight: "bold",
                    fontSize: "0.7rem",
                    height: "20px",
                    padding: "0 6px",
                    borderRadius: "12px",
                  }}
                />
              </Box>
            }
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <PersonOutlined color="primary" />}
            title="Driver Name"
            subtitle={vehicleListingDetail?.driverName || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <PhoneOutlined color="primary" />}
            title="Driver Number"
            subtitle={vehicleListingDetail?.driverNumber || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <PersonOutlined color="primary" />}
            title="Owner Name"
            subtitle={vehicleListingDetail?.ownerName || "N/A"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <PhoneOutlined color="primary" />}
            title="Owner Number"
            subtitle={vehicleListingDetail?.ownerNumber || "N/A"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <PhoneOutlined color="primary" />}
            title="Created By"
            subtitle={vehicleListingDetail?.createdBy?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InformationTile
            icon={() => <PhoneOutlined color="primary" />}
            title="Updated By"
            subtitle={vehicleListingDetail?.updatedBy?.name || "N/A"}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default VehicleListingBasicDetail;